import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import TimePickerProps from './TimePickerProps'

import Animation from '../Common/Animation'

export default {
    props: TimePickerProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Animation
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoTimePicker(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function () {
            that.$emit('changemodel', that.$refs.valueInput.value)
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoTimePicker()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoTimePicker/KendoTimePickerMixin.js